"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "mornago": {
    "420ed253": [{
      "hkey": "7a7de4e1",
      "slug": "mornago",
      "name": "Mornago",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-longina": [{
      "hkey": "7a7de4e1",
      "slug": "mornago",
      "name": "Mornago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "09b1541b": [{
      "hkey": "7a7de4e1",
      "slug": "mornago",
      "name": "Mornago",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-paccini": [{
      "hkey": "7a7de4e1",
      "slug": "mornago",
      "name": "Mornago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7afcc597": [{
      "hkey": "7a7de4e1",
      "slug": "mornago",
      "name": "Mornago",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-risora": [{
      "hkey": "7a7de4e1",
      "slug": "mornago",
      "name": "Mornago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "26fd5011": [{
      "hkey": "7a7de4e1",
      "slug": "mornago",
      "name": "Mornago",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-ronchetto": [{
      "hkey": "7a7de4e1",
      "slug": "mornago",
      "name": "Mornago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "689de279": [{
      "hkey": "7a7de4e1",
      "slug": "mornago",
      "name": "Mornago",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-rossi": [{
      "hkey": "7a7de4e1",
      "slug": "mornago",
      "name": "Mornago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9c3358cd": [{
      "hkey": "4ef7bf4b",
      "slug": "cascina-bosco-grosso-sarticcio",
      "name": "Cascina Bosco Grosso-Sarticcio",
      "primary": true,
      "skipSearch": false
    }],
    "c-na-sarticcio": [{
      "hkey": "4ef7bf4b",
      "slug": "cascina-bosco-grosso-sarticcio",
      "name": "Cascina Bosco Grosso-Sarticcio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "mornago"
    }],
    "ee248f42": [{
      "hkey": "4ef7bf4b",
      "slug": "cascina-bosco-grosso-sarticcio",
      "name": "Cascina Bosco Grosso-Sarticcio",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-bosco-grosso": [{
      "hkey": "4ef7bf4b",
      "slug": "cascina-bosco-grosso-sarticcio",
      "name": "Cascina Bosco Grosso-Sarticcio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f5076f6f": [{
      "hkey": "3ba26a6b",
      "slug": "crugnola-vinago",
      "name": "Crugnola-Vinago",
      "primary": true,
      "skipSearch": false
    }],
    "crugnola": [{
      "hkey": "3ba26a6b",
      "slug": "crugnola-vinago",
      "name": "Crugnola-Vinago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e05fd488": [{
      "hkey": "7a7de4e1",
      "slug": "mornago",
      "name": "Mornago",
      "primary": true,
      "skipSearch": false
    }],
    "crugnolino": [{
      "hkey": "7a7de4e1",
      "slug": "mornago",
      "name": "Mornago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3477b47a": [{
      "hkey": "7a7de4e1",
      "slug": "mornago",
      "name": "Mornago",
      "primary": true,
      "skipSearch": false
    }],
    "m-o-del-sogno": [{
      "hkey": "7a7de4e1",
      "slug": "mornago",
      "name": "Mornago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "52def08e": [{
      "hkey": "7a7de4e1",
      "slug": "mornago",
      "name": "Mornago",
      "primary": true,
      "skipSearch": false
    }],
    "monte-di-tordimonte": [{
      "hkey": "7a7de4e1",
      "slug": "mornago",
      "name": "Mornago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cacda760": [{
      "hkey": "7a7de4e1",
      "slug": "mornago",
      "name": "Mornago",
      "primary": true,
      "skipSearch": false
    }],
    "monte-la-torre": [{
      "hkey": "7a7de4e1",
      "slug": "mornago",
      "name": "Mornago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9840cb52": [{
      "hkey": "7a7de4e1",
      "slug": "mornago",
      "name": "Mornago",
      "primary": true,
      "skipSearch": false
    }],
    "ponte-della-strona": [{
      "hkey": "7a7de4e1",
      "slug": "mornago",
      "name": "Mornago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "86da3a50": [{
      "hkey": "7a7de4e1",
      "slug": "mornago",
      "name": "Mornago",
      "primary": true,
      "skipSearch": false
    }],
    "san-carlo": [{
      "hkey": "7a7de4e1",
      "slug": "mornago",
      "name": "Mornago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1914d35c": [{
      "hkey": "7a7de4e1",
      "slug": "mornago",
      "name": "Mornago",
      "primary": true,
      "skipSearch": false
    }],
    "san-gaetano": [{
      "hkey": "7a7de4e1",
      "slug": "mornago",
      "name": "Mornago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6165fcf2": [{
      "hkey": "7a7de4e1",
      "slug": "mornago",
      "name": "Mornago",
      "primary": true,
      "skipSearch": false
    }],
    "torretta": [{
      "hkey": "7a7de4e1",
      "slug": "mornago",
      "name": "Mornago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a8bd1035": [{
      "hkey": "3ba26a6b",
      "slug": "crugnola-vinago",
      "name": "Crugnola-Vinago",
      "primary": true,
      "skipSearch": false
    }],
    "vinago": [{
      "hkey": "3ba26a6b",
      "slug": "crugnola-vinago",
      "name": "Crugnola-Vinago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "mornago"
    }]
  }
};
exports["default"] = _default;